<template>
  <div>
    <div class="u-hd">
        <div class="hd-bk" @click="goBack">
            <i class="icon iconback" ></i>&nbsp;返回
        </div>
        <div class="hd-tl">库存信息报表</div>
        <div class="hd-mu" style="line-height: 44px;">
        </div>
    </div>
    <div style="height:44px"></div>
    <div class="search-fixed">
        <div class="search">
            <div class="search-lst">
                <div class="search-lst-tag">
                    <div class="icon icondingdanhao"></div>
                    <div class="lst-tag-vle">
                        <input 
                        style="width: 100%;height:28px;border:0px solid #ccc;line-height:28px;" 
                        placeholder-class="placeholder" v-model="text" placeholder="编号、条码、名称" @keyup.enter="search"/>
                    </div>
                </div>
                <div class="search-lst-tag" @click="$refs.selectPick.open()" v-if="$store.state.supplierInfo.businessType=='0'">
                    <div class="lst-tag-vle">
                        <div class="placeholder" v-if="!merchant.id">请选择组织机构</div>
                        <div v-else>{{merchant.name}}</div>
                    </div>
                </div>
            </div>
            <div class="search-lst" >
                <div class="search-lst-tag">
                    {{$store.state.supplierInfo.name}}
                </div>
                <div class="search-lst-tag" style="border-bottom:0px;">
                    <div class="search-btn-group">
                        <div class="search-btn" @click="search">
                            <div class="icon iconsousuo"></div>
                            <div style="padding-left:10px;">查询</div>
                        </div>
                        <div style="width:1px;height:20px;background:#bbb"></div>
                        <div class="search-btn" @click="clearSearch">
                            <div class="icon iconzhongzhi"></div>
                            <div style="padding-left:10px;">重置</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height:100px"></div>
    <div style="height: calc(100vh - 154px);margin-top:10px;padding:0px 10px" >
        <van-list
            v-if="list && list.length>0"
            v-model="loadData"
            :finished="allData"
            finished-text="数据已加载完毕"
            style="background-color: #FFF;"
            @load="onLoad"
            >
            <div style="display:flex;margin:0 12px;padding:10px;align-items: center;border-bottom:1px solid #ddd">
                <div style="width:100%;text-align: center;">
                    <div style="color:#486ad8;font-size:18px;" :style="{color:total.count>=0?'#486ad8':'#FC5531'}">{{total.count | money}}</div>
                    <div style="color:#888;font-size:12px;padding-top:10px;">库存数量合计</div>
                </div>
            </div>
            <div class="ct-order"  v-for="(item,index) in list" @click="showDetail(item,index)" :style="{backgroundColor:selectGoodId==item.goodsId?'#f8fbe3':''}">
                <div class="order-box">
                    <!-- pOneLine -->
                    <div class="box-nn">
                        <div class="nn-title-lft" style="flex: 1;">
                            <div style="color:#2f2f2f;font-size:15px;width: calc(100% - 90px);">{{item.name}}</div>
                            <div decode="true" style="color:#858585;font-size:12px;font-weight:500;padding:0 5px;"> ({{item.no}})</div>
                            <div class="arrowUp">
                                ↑
                            </div>
                        </div>
                    </div>
                    <div class="box-bttom">
                        <div class="ve-left">
                            <div>{{item.code?item.code:'无条码'}}</div>
                            <div>{{item.goodsSpec?item.goodsSpec:'无规格'}}</div>
                            <div>
                                <span>{{item.categoryName}}</span><span style="padding:0 3px;">/</span><span>{{item.brandName?item.brandName:'-'}}</span>
                            </div>
                            <div>{{item.supplierName?item.supplierName:'无供应商'}}</div>
                        </div>
                        <div class="ve-right" style="line-height:80px;text-align:center">
                            <span style="font-size:22px" :style="{color:item.count>=0?'#486ad8':'#FC5531'}">{{item.count  | money}}</span>
                            &nbsp;
                            <span style="padding-left:4px;font-size:12px;color:#555">({{item.unit}})</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
        <div v-else>
            <van-empty>
                <template slot="image">
                    <div style="text-align:center;margin-top:50px">
                        <i class="icon iconzanwushuju2" style="font-size:50px;color:#CCC"></i>
                    </div>
                    <div style="color:#CCC;text-align:center">暂无数据</div>
                </template>
            </van-empty>
        </div>
    </div>
    <select-time ref="selectTime" :type.sync="tabType" :typeText.sync="tabText" :st.sync="startTime" :et.sync="endTime"></select-time>
    <select-merchant ref="selectPick" title="选择组织机构" :item.sync="merchant"></select-merchant>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data(){
        return {
            text:'',
            list:[
            ],
            tabType:'0',
            tabText:'今日',
            currentPage:1,
            startTime: '',
            endTime: '',
            merchant:{},
            maxDate: new Date(),
            loadData:false,
            allData:false,
            show:false,
            total:{}
        }
    },
    created(){
        this.startTime = this.moment().format("YYYY-MM-DD");
        this.endTime = this.moment().format("YYYY-MM-DD");
        this.merchant=this.$store.state.supplierInfo.defOrg?this.$store.state.supplierInfo.defOrg:{}
        this.merchant=this.$store.state.supplierInfo.defOrg?this.$store.state.supplierInfo.defOrg:{}
        if(this.$store.state.supplierInfo.businessType=='0'){
            
        }else{
            this.search()
        }
        
    },
    methods:{
        search(){
            this.currentPage=1
            this.getData()
        },
        clearSearch(){
            this.currentPage=1
            this.merchant={}
            this.text=''
            this.getData()
        },
        onLoad(){
            this.currentPage++
            this.getData()
        },
        getData(){
            this.loadData=true
            this.$request.get("saleReports/queryStockReports",{keyword:this.text,pageNum:this.currentPage,pageSize:10,merchantId:(this.merchant.id?this.merchant.id:'')}).then(data=>{
                this.loadData=false
                if(data.status==200){
                    
                    this.total=data.content.totalSum?data.content.totalSum:{}
                    if(this.currentPage>1){
                        this.list=this.list.concat(data.content.page.content)
                    }else{
                        this.list=data.content.page.content
                    }
                    if(this.currentPage>=data.content.page.totalPage){
                        Toast.success('数据加载完毕');
                        this.allData=true
                    }else{
                        this.allData=false
                    }
                }else{
                    Toast.fail(data.message)
                }
            })
        },
        changeTabType(type) {
            this.tabType=type
            let startTime=''
            let endTime=''
            if (type == '0') {
                this.tabText='今日'
                startTime = this.moment().format("YYYY-MM-DD");
                endTime = this.moment().format("YYYY-MM-DD");
            } else if (type == '1') {
                this.tabText='昨日'
                startTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
                endTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
            } else if (type == '2') {
                this.tabText='近一周'
                startTime = this.moment().subtract(7, 'days').format("YYYY-MM-DD")
                endTime = this.moment().format("YYYY-MM-DD")
            } else if (type == '3') {
                this.tabText='近一月'
                endTime = this.moment().format("YYYY-MM-DD")
                startTime = this.moment().format("YYYY-MM-01")
            } else if (type == '4') {
                this.tabText='自定义数据'
                endTime = new Date(this.moment().format("YYYY-MM-DD"))
                startTime = new Date(this.moment().format("YYYY-MM-01"))
            }
            this.currentPage=1
            this.startTime=startTime
            this.endTime=endTime
            this.getData()
        },
        goBack(){
            this.router.go(-1)
        }
    }
}
</script>

<style scoped>
    .search-fixed{
        z-index: 10;
        position: fixed;
        width: 100%;
        top: 44px;
        left: 0px;
        background-color: #F2F2F2;
        padding: 10px;
        box-sizing: border-box;
        padding-bottom: 0px;
    }
    .search{ 
        /* border-radius: 10rpx; */
        padding:0px 15px 10px 15px;
        background: #FFF;
    }
        /* list搜索box每行样式 */
    .search-lst{
        display:flex;
        justify-content:space-between
    }
    /* list搜索框样式 */
    .search-lst-tag{
        width:48%;
        height:40px;
        line-height: 40px;
        padding-top:5px;
        display: flex;
        border-bottom:1px solid #eee
    }
        /* 搜索框图标样式 */
    .search-lst-tag .icon{
        font-size:18px;
        color:#aaa
    }
        /* 搜索框内容样式 */
    .lst-tag-vle{
        flex:1;
        text-align:center;
        color:#666;
        font-size:13px;
    }
    /* 搜索框未选中样式 */
    .lst-tag-vle .placeholder{
        color:#adadad;
        font-size:13px;
        text-align: left;
    }
        /* 搜索框按钮Box */
    .search-btn-group{
        width:100%;
        display:flex;
        border-radius:4px;
        background:#777;
        display:flex;
        align-items:center;
        justify-content:space-between
    }
        /* 搜索框按钮样式 */
    .search-btn{
        color:#fff;
        display:flex;
        width:49%;
        justify-content:center;
        font-size:14px;
    }
.u-search{
    display: flex;
    height: 40px;
    line-height: 40px;
    align-items: center;
}
.u-search .input-place{
    font-size: 14px;
    color: #DDD
}
.u-search .search-box{
    width: calc(100% - 85px);
    display: flex;
    margin:0px 10px;
    background-color: #FFF;
    height: 100%;
    border-radius: 20px;
    padding-left: 15px;
    align-items: center;
}
.u-search .search-box .box-input{
    width: calc(100% - 40px);
}
.u-search .search-box .box-input input{
    border: 0px;
    color: #666;
    font-size: 14px;
    background: rgba(0,0,0,0);
    height: 100%;
}
.u-search .search-box .box-input .input-place{
    color: #ccc;
}
.u-search .search-box .box-icon{
    width: 40px;
    display: flex;
    align-items: center;
    padding-top: 17px;
}
.search-filter{
    font-size: 14px;
    width: 75px;
    display: flex;
    margin:0px 10px;
    height: 40px;
    align-items: center;
    color: #F9F9F9;
    position: relative;
    background: #486ad8;
}
.search-filter .filter-clr{
    text-align: center;
}
.search-filter .filter-clr div{
    color: #FFF;
}
.search-filter .filter-ser{
    flex: 1;
    text-align: center;
}
.search-filter text{
    color: #F9F9F9;
    font-size: 15px;
}
.search-filter .icon{
    font-size: 22px
}
.search-filter .filter-list{
    position: absolute;
    background: rgba(0,0,0,0.6);
    top: 45px;
    width:90px;
    right:10px;
    z-index: 10;
    text-align: center;
    padding:20px;
    padding-top: 5px;
}
.search-filter .list-item{
    color: #FFF;
    border-bottom:1px solid #888;
    font-size: 14px;
    text-align: left;
    height:40px;
    line-height: 40px
}
.m-ct{
    padding: 0px 10px;
}

.ct-order{
  padding: 10px;
  display: flex;
  border-bottom: 1px solid #DDD;
}
.ct-order .order-item{
  width: 40px;
  text-align: center;
  padding-top: 8px;
  box-sizing: border-box;
}
.ct-order .order-item .item-icon text{
  color: #ccc;
  font-size: 18px
}
.ct-order .order-box{
  width: 100%;
}
.ct-order .order-box .box-nn{
  font-weight: 500;
  font-size: 15px;
  display:flex;
  padding-bottom:8px;
  justify-content:space-between;
  align-items: flex-end;
}
.ct-order .order-box .nn-title-lft{
  display: flex;
  align-items: flex-end;
}
.ct-order .order-box .nn-title-lft .arrowUp{
  background:#ff8529;
  color:#fff;
  border-radius:50%;
  font-size:12px;
  width:15px;
  height:15px;
  line-height: 15px;
  text-align: center;
}
.icon-ls{
  color: #486ad8 !important;
}
.ct-order .order-box .box-bttom{
  display: flex;
}
.ct-order .order-box .box-bttom .ve-left{
  width: 60%;
  padding:0 5px;
  margin:5px 0;
  border-right:1px solid #ddd
}
.ct-order .order-box .box-bttom .ve-left div{
  font-size:12px;
  padding-bottom:3px;
  font-weight: 300;
  color:#858585
}
.ct-order .order-box .box-bttom .ve-right{
  width: 60%;
  padding:0 5px;
  margin:5px 0;
}
.ct-order .order-box .box-bttom .ve-right .right-top{
  padding:10px 5px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom:1px solid #ddd
}

.ct-order .order-box .box-bttom .ve-right .right-bottom{
  text-align: right;
}
.sum{
    color:#4c37b6
}
.sum .sum-txt{
    font-size: 12px;
}
.sum .sum-val{
    font-size: 16px;
}
.numColor{
}
.link-item{
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #666;
    color: #fff;
    display: flex;
}
.right-menu{
    position: fixed;
    top: 44px;
    right: 0px;
    /* z-index: 10; */
    background-color: #42474A;
    color: #FFF;
    z-index: 10;
    height: calc(100vh - 44px);
    width: 50vw;
}

</style>


// WEBPACK FOOTER //
// src/views/report/goodsStockSumReport.vue